<template>
	<layout-admin>
		<div class="py-6 px-4 sm:px-6 lg:px-8">
			<ui-alert
				v-if="success"
				type="success"
				:message="success == true ? 'Your inputs have been saved!' : success"
			/>
			<ui-alert v-if="error" type="error" :message="error" />

			<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
				<ui-button
					class="ml-auto text-lg shadow-xl"
					label="Save"
					v-on:click="submitForm()"
					:disabled="submitButtonDisabled"
				/>
			</div>

			<h1 class="text-3xl font-semibold text-gray-900 mb-4">
				{{ __("Beitrag") }} {{ newsItem.id }} {{ __("bearbeiten") }}
			</h1>

			<div class="pb-8 px-6 fixed top-24 flex right-0 z-10">
				<ui-button
					type="secondary"
					v-on:click="$inertia.visit(backUrl)"
					class="flex items-center"
				>
					{{ __("Back") }}
				</ui-button>
			</div>

			<div class="pb-8 px-6 fixed top-24 flex right-28 z-10">
				<ui-button
					type="button"
					class="bg-red-500 rounded-lg shadow-sm py-2 px-4 font-medium text-white focus:ring-2 focus:ring-red-200"
					v-on:click="showDeleteModal = true"
					>{{ __("Delete") }}</ui-button
				>
				<ui-modal
					v-if="showDeleteModal"
					:small="true"
					:key="'MODAL_' + showDeleteModal"
					v-on:close="showDeleteModal = false"
					ref="deleteModal"
					:confirm-label="__('Delete')"
					v-on:confirm="deleteNews()"
					>{{ __("Do you want to delete this news item?") }}</ui-modal
				>
			</div>

			<div class="grid grid-cols-8 gap-y-4 gap-x-6">
				<ui-input-group
					class="col-span-4"
					v-model="form.title"
					label="Title"
					:form="form"
					field="title"
					:required="true"
				/>

				<ui-input-group
					class="col-span-4"
					v-model="form.market_news_items_order"
					label="Order"
					:form="form"
					field="market_news_items_order"
					:required="true"
				/>

				<ui-textarea-group
					class="col-span-4"
					v-model="form.text"
					field="text"
					label="Text"
					:form="form"
					:required="false"
					:rows="10"
					:maxWProse="false"
				/>

				<div class="col-span-4">
					<label class="block font-medium">{{ __("Title Image") }}</label>
					<input
						type="file"
						@input="form.titleImage = $event.target.files[0]"
					/>
					<ui-validation-message :form="form" field="titleImage" />
					<div v-if="form.title_image" class="max-w-sm">
						<img :src="imageUrl" class="mx-auto mt-8" />
					</div>
					<ui-input-group
						class="mt-3"
						v-model="form.title_image_url"
						label="Image URL"
						:form="form"
						field="title_image_url"
						:required="false"
					/>
				</div>
			</div>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
export default {
	props: {
		newsItem: {
			type: Object,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		this.newsItem.titleImage = null;
		return {
			form: Vue.observable(this.$inertia.form(this.newsItem)),
			submitButtonDisabled: false,
			showDeleteModal: false,
		};
	},
	computed: {
		backUrl() {
			return (
				window.baseUrl + "/admin/market-news/" + this.newsItem.market_news_id
			);
		},
		imageUrl() {
			let updatedAt = new Date(this.newsItem.updated_at);
			return (
				window.baseUrl +
				"/admin/market-news/item/" +
				this.newsItem.id +
				"/image?ts=" +
				updatedAt.getTime()
			);
		},
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "post",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onError(e) {
					console.log("form submit error:", e);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
		async deleteNews() {
			let endpoint =
				window.baseUrl + "/admin/market-news/item/" + this.newsItem.id;
			this.$inertia.delete(endpoint);
			this.showDeleteModal = false;
			this.$emit("close");
		},
	},
};
</script>
